.tab {
  flex: none;
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
  position: relative;
  bottom: -1px;
  padding: 6px 12px;
  height: 44px;

  border: 1px solid transparent;
  border-bottom: none;
  border-radius: 2px 2px 0 0;

  color: var(--default--text-color--16);
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  list-style: none;
  cursor: pointer;

  &:focus-visible {
    outline: solid 1px var(--primary--focus--border-color--3);
    outline-offset: -1px;
    box-shadow: 0 0 4px var(--primary--focus--box-shadow-color--1);

    color: var(--primary--focus--text-color--1);
    font-weight: 400;
  }

  &:hover {
    color: var(--primary--hover--text-color--3);
  }
}

.selected-tab {
  background: var(--light--background-color--1);

  border-color: var(--default--border-color--12);
  border-radius: 4px 4px 0 0;

  color: var(--default--text-color--17);
  font-weight: 500;

  cursor: default;

  &:hover {
    color: var(--default--text-color--17);
  }

  &:focus-visible {
    background: var(--default--background-color--14);

    outline: none;
    border-color: var(--primary--focus--border-color--3);
    box-shadow: 0 0 4px -2px var(--primary--focus--box-shadow-color--1);

    color: var(--primary--focus--text-color--1);
    font-weight: 500;
  }
}
